import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy, faGraduationCap, faBullseye, faRotateRight } from '@fortawesome/free-solid-svg-icons';
import './PlanCompleteCard.css';

/**
 * Shown once every activity in the learning plan is completed. Without it the
 * plan simply runs out: users are left thinking their learning is over (or that
 * someone else has to unlock the next part) when they can set a new goal
 * themselves at any time.
 *
 * The evaluation leads because it is the only thing that answers "what now?"
 * with evidence — it ends on a recommendation of what to work on next, which is
 * what the new goal should be built on.
 */
function PlanCompleteCard({ activityCount, onTakeEvaluation, onCreateNewPlan, onPracticeAgain }) {
  const { t } = useTranslation();

  return (
    <div className="plan-complete-card">
      <div className="plan-complete-icon" aria-hidden="true">
        <FontAwesomeIcon icon={faTrophy} />
      </div>
      <h3 className="plan-complete-title">
        {t('learning_plan_complete_title', "You've completed your learning plan!")}
      </h3>
      <p className="plan-complete-description">
        {t(
          'learning_plan_complete_description',
          'Great work — you finished all {{count}} activities. Take the evaluation to see where you stand and what to work on next, then set your new goal from it.',
          { count: activityCount }
        )}
      </p>
      <button
        className="button activity plan-complete-primary"
        onClick={onTakeEvaluation}
      >
        <FontAwesomeIcon icon={faGraduationCap} className="plan-complete-button-icon" />
        {t('test_learning_path')}
      </button>
      <button
        className="button activity plan-complete-secondary"
        onClick={onCreateNewPlan}
      >
        <FontAwesomeIcon icon={faBullseye} className="plan-complete-button-icon" />
        {t('create_new_learning_plan', 'Set a new learning goal')}
      </button>
      <button
        className="button activity plan-complete-secondary"
        onClick={onPracticeAgain}
      >
        <FontAwesomeIcon icon={faRotateRight} className="plan-complete-button-icon" />
        {t('practice_activity_again', 'Practice an activity again')}
      </button>
    </div>
  );
}

export default PlanCompleteCard;
